var React = require('react');

function Shape (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"o-grupie","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"o-grupie-Mobile","transform":"translate(-11.000000, -1436.000000)","stroke":"#F2C1B6","strokeWidth":"2.5"},React.createElement("path",{"d":"M308.176477,1437.25 L302.985512,1450.67494 L308.523311,1483.75 L13.7425,1483.75 L33.9492086,1460.5 L13.7425,1437.25 L308.176477,1437.25 Z","id":"Rectangle-Copy-7"}))));
}

Shape.defaultProps = {"preserveAspectRatio":"none","width":"299px","height":"49px","viewBox":"0 0 299 49","version":"1.1"};

module.exports = Shape;

Shape.default = Shape;
